import {
  EndPointsNames,
  ApiCredentialsType,
  ErrorResponseCodeType,
} from '_core/types';
import { setEntityName } from '_core/util/object';

export const API_DOMAIN: EndPointsNames = 'ApiAccount';
export const ENDPOINT_API_PATH = 'v1/members/email';
export const ENTITY_NAME = setEntityName(ENDPOINT_API_PATH);
const API_CREDENTIALS_TYPE: ApiCredentialsType =
  'TOKEN_AUTH_USER_OR_CREDENTIALS';
const URL_POSTMAN =
  'https://smiles-sa.postman.co/workspace/1aa3f7db-730f-4a9e-8904-3201cc3d9669/api/aee25e72-037a-410a-8bbe-32c3ee1cd92e';

export const CODE_ERRORS: ErrorResponseCodeType[] = [
  {
    code: '1',
    message:
      'Ocorreu um erro técnico (Erro inesperado, favor contactar a Smiles)',
    bussinessErrorVariant: 'errorService',
  },
  {
    code: '6',
    message: 'Email vinculado a este CPF',
    bussinessErrorVariant: 'emailLinkedDocument',
  },
  {
    code: '7',
    message: 'Email vinculado a outro CPF',
    bussinessErrorVariant: 'emailLinkedOtherDocument',
  },
];

export default {
  API_DOMAIN,
  ENDPOINT_API_PATH,
  API_CREDENTIALS_TYPE,
  URL_POSTMAN,
  CODE_ERRORS,
  ENTITY_NAME,
};
